module.exports = __webpack_public_path__ + "static/media/logo-horizontal.a9201c72.png";